var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMaximize = function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "maximize_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgMaximize as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNOCAzSDVDNC40Njk1NyAzIDMuOTYwODYgMy4yMTA3MSAzLjU4NTc5IDMuNTg1NzlDMy4yMTA3MSAzLjk2MDg2IDMgNC40Njk1NyAzIDVWOE0yMSA4VjVDMjEgNC40Njk1NyAyMC43ODkzIDMuOTYwODYgMjAuNDE0MiAzLjU4NTc5QzIwLjAzOTEgMy4yMTA3MSAxOS41MzA0IDMgMTkgM0gxNk0xNiAyMUgxOUMxOS41MzA0IDIxIDIwLjAzOTEgMjAuNzg5MyAyMC40MTQyIDIwLjQxNDJDMjAuNzg5MyAyMC4wMzkxIDIxIDE5LjUzMDQgMjEgMTlWMTZNMyAxNlYxOUMzIDE5LjUzMDQgMy4yMTA3MSAyMC4wMzkxIDMuNTg1NzkgMjAuNDE0MkMzLjk2MDg2IDIwLjc4OTMgNC40Njk1NyAyMSA1IDIxSDgiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";